<template>
  <transition name="show">
    <div
      class="menuSlider sticky-menu bg-white h-14 w-full flex items-center fixed z-130"
      :class="{
        'sticky-menu-show': showMenu,
        'sticky-menu-hide': !showMenu,
      }"
    >
      <Swiper :settings="settings" class="w-full" @swiper="onSwiper">
        <SwiperSlide v-for="(item, index) in list" :key="item.id">
          <OButton
            pure
            :class="{
              'bg-black text-white border-black': index === activeIndex,
              'text-primary-200 border-divider-100': index !== activeIndex,
            }"
            class="h-8 u-center border px-4 mr-4 rounded-full font-medium text-md whitespace-nowrap"
          >
            {{ item.title }}
          </OButton>
        </SwiperSlide>
      </Swiper>
    </div>
  </transition>
</template>
<script>
import { defineComponent, onMounted, ref, computed } from '@nuxtjs/composition-api';
import { throttle } from 'lodash';
import Swiper from '@/modules/sliders/core/Swiper';
import SwiperSlide from '@/modules/sliders/core/SwiperSlide';
import { OButton } from '~/modules/common/components/ui';
import { useWidgetObserver } from '~/modules/homepage/utils/useWidgetObserver';

export default defineComponent({
  props: {
    items: {
      type: Object,
      default: {},
    },
  },
  components: {
    Swiper,
    SwiperSlide,
    OButton,
  },
  setup(props) {
    const activeIndex = ref(-1);
    const pageYOffset = ref(0);
    const showMenu = ref(false);
    const ignoreObserver = ref(false);

    // menu data
    const categoryList = ref(props.items.config.components);
    const categoryData = ref(props.items.widgetMap);
    const list = categoryList.value
      .map((item) => {
        const id = item.widgets[0].id;
        return {
          id,
          title: categoryData.value[id].title,
        };
      })
      .filter((item) => item.title !== '' && item.id !== 'leaderboard');

    // menu visibility
    const menuVisibility = () => {
      window.onscroll = throttle(() => {
        showMenu.value = window.pageYOffset > 200;
        pageYOffset.value = window.pageYOffset;
        // Commented out because its moved from top to bottom
        // const header = document.getElementsByClassName('header__wrapper')[0];
        // const hasShadow = header?.classList.contains('menu-shadow');
        // if (showMenu.value && hasShadow) {
        //   header.classList.remove('menu-shadow', 'border-b');
        // } else if (header && !showMenu.value && !hasShadow) {
        //   header.classList.add('menu-shadow');
        // }
      }, 200);
    };

    // slider settings
    const settings = computed(() => ({
      slidesPerView: 'auto',
      centeredSlides: true,
      centeredSlidesBounds: true,
      slideToClickedSlide: true,
    }));

    // slider click
    const swiperRef = ref(null);
    const onSwiper = (swiper) => {
      swiperRef.value = swiper;
      swiper.on('click', () => {
        ignoreObserver.value = true;
        activeIndex.value = swiper.clickedIndex;
        const targetSection = document.getElementById(list[activeIndex.value].id);
        if (!targetSection) return;
        window.scrollTo({
          top: targetSection.offsetTop - 132,
          behavior: 'smooth',
        });
        setTimeout(() => {
          ignoreObserver.value = false;
        }, 1000);
      });
    };

    onMounted(() => {
      menuVisibility();

      // window scroll observer for widgets
      useWidgetObserver((entries) => {
        if (ignoreObserver.value) return;
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.id.replace('-start', '').replace('-end', '');
            const index = list.findIndex((item) => item.id === id);
            if (index === -1) return;
            activeIndex.value = index;
            swiperRef.value?.slideToLoop(index, 100);
          }
        });
      }, props.items.config.components);
    });

    return { activeIndex, showMenu, list, settings, onSwiper };
  },
});
</script>
<style lang="scss" scoped>
.menuSlider {
  .swiper {
    padding-left: 20px;
    padding-right: 20px;
  }
  .swiper-slide {
    width: auto !important;
  }
}
.show-leave-active {
  transition: 0.5s all;
}
.show-leave-to {
  bottom: -88px !important;
}
.sticky-menu {
  transition: 0.5s all;
  &.sticky-menu-show {
    bottom: 0px;
  }
  &.sticky-menu-hide {
    bottom: -88px;
  }
}
</style>
